import { IComponentOptions } from "angular";

export const ToggleRightDownArrowComponent: IComponentOptions = {
  bindings: {
    isOpen: "<",
  },
  templateUrl: require("./toggle-right-down-arrow.jade"),
};
